import { FilterUserActions, FilterUserActionTypes } from './user.actions';
import { IUsersFilterData } from '../../../shared/component/filter/filter.class';
import { Action } from '@ngrx/store';

export interface FilterUserState {
  isLoading: boolean;
  isLoaded: boolean;
  data: IUsersFilterData[];
}

export const initialFilterUserState: FilterUserState = {
  isLoaded: false,
  isLoading: false,
  data: [],
};

export function filterUserReducer(state = initialFilterUserState, baseAction: Action): FilterUserState {
  const action = baseAction as FilterUserActions;

  switch (action.type) {
    case FilterUserActionTypes.START_LOAD_FILTER_USERS:
      return { ...state, isLoading: true };

    case FilterUserActionTypes.FILTER_USERS_LOADED:
      return { ...state, data: action.data, isLoaded: true, isLoading: false };

    case FilterUserActionTypes.RESET_USER_STORE:
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        data: [],
      };
    default:
      return state;
  }
}
